<template>
  <section class="old-buy">
    <div class="osk-wrapper">
      <div class="old-buy__content">
        <h2 class="section-title old-buy__title">
          {{ $t('components.home.old.buy.title') }}
        </h2>

        <p class="old-buy__text">
          {{ $t('components.home.old.buy.text1') }}
        </p>

        <p class="old-buy__text">
          {{ $t('components.home.old.buy.text2') }}
        </p>

        <a
          class="old-buy__link"
          href="/info/buyer"
        >
          {{ $t('common.moreDetails') }}
        </a>
      </div>

      <div class="old-buy__image-block">
        <picture>
          <source
            srcset="//oskelly.ru/images/icons/about_img.png"
            type="image/webp"
          >
          <source
            srcset="//static.oskelly.ru/images/icons/about_img.png"
            type="image/jpeg"
          >
          <img
            class="old-buy__image"
            src="//static.oskelly.ru/images/icons/about_img.png"
            :alt="$t('components.home.old.buy.startSale')"
          >
        </picture>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.old-buy {
  padding: 33px 0px 40px;
  background: rgba(245, 245, 245, 0.5);

  @media screen and (min-width: 1024px) {
    padding: 80px 0;
  }

  .osk-wrapper {
    display: flex;
    flex-direction: column;

    @media screen and (min-width: 1024px) {
      align-items: center;
      justify-content: space-between;
      flex-direction: row;
    }
  }

  &__title {
    margin-bottom: 12px;
    text-align: left;
    order: 1;

    @media screen and (min-width: 767px) {
      margin-bottom: 30px;
    }

    @media screen and (min-width: 1024px) {
      padding: 16px 16px 0 0;
    }
  }

  &__content {
    @media screen and (min-width: 1024px) {
      padding-right: 16px;
      max-width: 471px;
    }
  }

  &__text {
    margin-bottom: 20px;
    font-size: 12px;
    line-height: 17px;

    @media screen and (min-width: 1024px) {
      font-size: 16px;
      line-height: 24px;
    }
  }

  &__link {
    display: block;
    height: 46px;
    color: #141414;
    text-align: center;
    line-height: 44px;
    transition: .3s;
    border: 1px solid #141414;
    border-radius: 2px;
    font-size: 14px;

    &:hover {
      opacity: .5;
    }

    @media screen and (min-width: 767px) {
      display: inline-block;
      width: 294px;
    }
  }

  &__image-block {
    display: none;

    @media screen and (min-width: 1024px) {
      display: table-cell;
      vertical-align: top;
      width: 50%;
      margin-bottom: 12px;
    }
  }

  &__image {
    width: 100%;
  }
}
</style>
